import client from '../../providers/fetchClient'

export const createCcb = data => client.post('/v3/ccbs', data)
